import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { paymentAuditStatusFilterOptions } from '@new/__global/constants/filter'
import { AuditPaymentStatus } from '@new/__global/types/paymentAudit.types'

import { FiltersSharedProps } from './Filters.types'

interface PaymentAuditStatusFilterProps extends FiltersSharedProps {
  initialValue?: AuditPaymentStatus[]
  onChange: (value?: AuditPaymentStatus[]) => void
  shouldUpdateOnInitialValueChange?: boolean
  title: string
}

export const PaymentAuditStatusFilter: FC<PaymentAuditStatusFilterProps> = ({
  initialValue,
  onChange,
  shouldUpdateOnInitialValueChange,
  title,
}) => (
  <CheckboxBasedFilter
    options={paymentAuditStatusFilterOptions}
    title={title}
    onChange={onChange}
    initialValue={initialValue}
    shouldUpdateOnInitialValueChange={shouldUpdateOnInitialValueChange}
  />
)
